import { useState } from 'react';
import { BookOpen } from 'lucide-react';

/**
 * Drop-in replacement for book cover <img> tags.
 * - Native lazy loading + async decoding
 * - Fades in on load (parent bg-cream-dark acts as skeleton)
 * - Graceful fallback icon on error or missing src
 * - className is applied to both the img and the fallback div
 */
export default function LazyBookCover({ src, alt = '', className = '', iconClassName = 'w-1/3' }) {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (!src || error) {
    return (
      <div className={`w-full h-full flex items-center justify-center ${className}`}>
        <BookOpen className={`${iconClassName} text-ink-muted`} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'} ${className}`}
      onLoad={() => setLoaded(true)}
      onError={() => setError(true)}
    />
  );
}
